import { gql, useMutation } from '@apollo/client'

export const FOLLOW_TAG = gql`
  mutation ($tag_id: String!) {
    followTag(tag_id: $tag_id) {
      id
    }
  }
`

export const useFollowTag = () => {
  const [mutate, { data, error, loading }] = useMutation(FOLLOW_TAG, {
    update(cache) {
      cache.modify({
        fields: {
          getUserTagFollows() {}
        }
      })
    }
  })
  return { mutate, data, error, loading }
}
